import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function FacilitySection() {
  // Placeholders for facility images
  const images = ['https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?q=80&w=2069&auto=format&fit=crop', 'https://images.unsplash.com/photo-1518310383802-640c2de311b2?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1626224583764-847890e058f5?q=80&w=2070&auto=format&fit=crop', 'https://images.unsplash.com/photo-1555597673-b21d5c935865?q=80&w=2072&auto=format&fit=crop' // Kids
  ];
  return <section id="facility" className="py-24 bg-white" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16" data-id="element-87">
          <div data-id="element-88">
            <div className="inline-flex items-center gap-2 text-[#FF6B35] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-89">
              <MapPin className="w-4 h-4" data-id="element-90" />
              Bloomington, IL
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-black mb-6" data-id="element-91">
              Train in Our New <br data-id="element-92" />
              <span className="text-[#00D4FF]" data-id="element-93">8,000 Sq. Ft. Facility</span>
            </h2>
            <p className="text-lg text-gray-600 mb-6" data-id="element-94">
              We've built the ultimate training environment for our students.
              Our spacious, clean, and modern facility is designed to provide
              the best possible martial arts experience.
            </p>
            <ul className="space-y-4 text-gray-700" data-id="element-95">
              <li className="flex items-center gap-3" data-id="element-96">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-97" />
                Professional grade mats and safety equipment
              </li>
              <li className="flex items-center gap-3" data-id="element-98">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-99" />
                Spacious viewing area for parents
              </li>
              <li className="flex items-center gap-3" data-id="element-100">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-101" />
                Clean locker rooms and restrooms
              </li>
              <li className="flex items-center gap-3" data-id="element-102">
                <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-103" />
                Pro shop for all your gear needs
              </li>
            </ul>
          </div>

          <div className="relative" data-id="element-104">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl" data-id="element-105">
              <img src={images[0]} alt="Main Training Floor" className="w-full h-full object-cover" data-id="element-106" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-[#00D4FF] -z-10 rounded-xl" data-id="element-107" />
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#FF6B35]/20 -z-10 rounded-full" data-id="element-108" />
          </div>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-109">
          {images.slice(1).map((img, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="aspect-square rounded-xl overflow-hidden group cursor-pointer" data-id="element-110">
              <img src={img} alt={`Facility view ${idx + 1}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-111" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}